export default {
    namespaced: true,
    state: {
        is_call: false,
        entry_flag: false
    },
    mutations: {
        // 他機能から呼び出されたかフラグをセット
        setIsCall(state, is_call) {
            state.is_call = is_call;
        },
        // 参加状況をセット
        setEntryFlag(state, entry_flag) {
            state.entry_flag = entry_flag;
        }
    },
    actions: {},
    getters: {
        // 他機能から呼び出されたかフラグを取得
        getIsCall(state) {
            return state.is_call;
        },
        // 参加状況を取得
        getEntryFlag(state) {
            return state.entry_flag;
        }
    }
};
